import { authStore } from '@tom-ui/utils'
import { ContainerHistoryApi, ContainerHistoryQueryResult } from '../app/api'
import { createApiClient } from '../app/http-client'

class ContainerHistoryService {
  httpClient = createApiClient(ContainerHistoryApi)

  getContainerHistory = async (
    containerId: number,
    turnoverId?: string,
  ): Promise<ContainerHistoryQueryResult> => {
    const { data } = await this.httpClient.integrationApiInternalContainerHistoryContainerIdGet(
      containerId,
      authStore.tenantId,
      turnoverId,
    )

    return data
  }
}

const containerHistoryService = new ContainerHistoryService()

export default containerHistoryService
